<!-- eslint-disable vue/html-self-closing -->
<template>
  <div class="preview">
    <div class="preview__inner">
      <div class="preview__header">
        <el-row>
          <el-col :span="10">
            <h2>{{ $t('preview.title') }}</h2>
          </el-col>
          <el-col :span="14" style="text-align: right;">
            <el-select v-model="selectTemplate" :placeholder="$t('preview.selectTemplate')">
              <el-option v-for="item in template.list" :key="item.value" :label="$t(`template.${item.key}`)" :value="item.value" />
            </el-select>
            <el-select v-model="locale" class="locale">
              <el-option v-for="item in app.locales" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-col>
        </el-row>
      </div>
      <div class="email">
        <div class="email-content">
          <div class="line short" style="margin-bottom: 30px;" />
          <div class="flex">
            <div class="column-1">
              <div class="line long full" />
              <div class="line long full" />
              <div class="line long full" />
              <div class="line long full" />
              <div class="line long full" />
              <div class="line long full" />
            </div>
          </div>
          <div class="line long" />
          <div class="line long full" />
          <div class="line long full" />
        </div>
        <div ref="preview" class="email-preview">
          <component :is="signatureTemplate" ref="template" />
        </div>
      </div>
      <div class="actions">
        <el-button-group>
          <el-button size="small" @click="copySelect">{{ $t('common.button.copyAsSelect') }}</el-button>
        </el-button-group>
        <br />
      </div>
      <textarea ref="html" style="opacity: 0" />
    </div>
    <el-dialog :title="$t('preview.viewSource.title')" :visible.sync="showSource">
      <p>{{ $t('preview.viewSource.description') }}</p>
      <br />
      <el-input ref="dialogSource" v-model="html" type="textarea" :rows="10" />
      <div style="text-align: right;" class="dialog-actions">
        <el-button type="primary" @click="copySource">{{ $t('common.button.copy') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'Preview',

  data() {
    return {
      html: '',
      showSource: false,
      version: require('../../package.json').version
    };
  },

  computed: {
    ...mapState(['app', 'template']),
    ...mapGetters({
      basic: 'getBasic',
      options: 'getOptions',
      template: 'getTemplate'
    }),
    signatureTemplate() {
      let template = this.template.selected;
      return () => import(`./templates/${template}`);
    },
    selectTemplate: {
      get() {
        return this.template.selected;
      },
      set(v) {
        this.$store.dispatch('updateTemplate', v);
      }
    },
    locale: {
      get() {
        return this.app.locale;
      },
      set(v) {
        const path = `/${v}/${this.$route.name}`;
        this.$router.push(path);
        this.$store.dispatch('setLocale', v);
      }
    },
    isProd() {
      return process.env.NODE_ENV === 'production';
    },
    isClientVersion() {
      return this.app.version === 'client';
    }
  },

  methods: {
    parseHTML() {
      return this.$refs.template.$el.outerHTML.replace(/<!---->/g, '');
    },
    copyHTML() {
      this.$refs.html.innerHTML = this.parseHTML();
      this.$refs.html.select();
      document.execCommand('copy');
      this.gaEventClick('copy as HTML');
    },
    copySelect() {
      if (window.getSelection) {
        let range = document.createRange();
        range.selectNode(this.$refs.preview.querySelector('.email-preview div'));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand('copy');
        this.gaEventClick('copy as select');
      }
    },
    viewSource() {
      this.html = this.parseHTML();
      this.showSource = true;
      this.gaEventClick('view source');
    },
    copySource() {
      this.$refs.dialogSource.select();
      document.execCommand('copy');
      this.gaEventClick('copy source');
      this.showSource = false;
    }
  }
};
</script>

<style lang="scss">
@import '../assets/scss/variables.scss';

.preview {
  background-color: #f6f6f6;
  padding: 40px 50px 20px 50px;
  overflow-y: auto;
  display: grid;
  grid-template-rows: 1fr 50px;
  &__header {
    margin-bottom: 20px;
  }
  &__inner {
    max-width: 900px;
  }
  &__footer {
    max-width: 900px;
    text-align: right;
    align-self: flex-end;
  }
  h2 {
    line-height: 0;
  }
  p {
    margin: 0;
  }
  .actions {
    text-align: right;
    margin-top: 20px;
  }
}
.email {
  min-height: 350px;
  width: 100%;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  &-content {
    padding: 20px;
    p {
      line-height: 1.5em;
      margin-bottom: 10px;
      font-size: 13px;
    }
    .line {
      height: 10px;
      background-color: #eee;
      margin: 10px 0;
      border-radius: 2px;
      &.short {
        width: 30%;
      }
      &.long {
        width: 90%;
      }
      &.half {
        width: 50%;
      }
      &.full {
        width: 100%;
      }
    }
    .flex {
      display: flex;
      width: 100%;
      margin-bottom: -10px;
      .column-1 {
        .line {
          &:first-of-type {
            margin-top: 0;
          }
        }
      }
      .column-1,
      .column-2 {
        flex-grow: 1;
      }
      .column-1 {
        width: 100%;
      }
      .column-2 {
        flex-shrink: 0;
        min-width: 320px;
      }
    }
  }
  &-preview {
    padding: 20px;
  }
  .placeholder {
    height: 100px;
    width: 100px;
    background-color: #eee;
    line-height: 0;
    font-size: 0;
  }
}
.setup-instruction {
  font-size: 10px;
}
.dialog-actions {
  text-align: right;
  margin-top: 20px;
}
.version {
  color: #aaa;
  margin-top: 10px;
  font-size: 10px;
  a {
    color: #aaa;
  }
  span {
    + span {
      &::before {
        content: '•';
        padding: 0 5px;
      }
    }
  }
  svg {
    width: 20px;
    position: relative;
    top: 5px;
    transition: all 0.2s;
  }
}
.link {
  text-decoration: underline;
  color: $color-primary;
  cursor: pointer;
}
.locale {
  margin-left: 10px;
  width: 80px;
}
</style>
